<template>
  <div class="p-3 min-h-[80vh]">
    <button
      @click="closeMode"
      class="bg-blue-500 p-2 text-white text-xs rounded hover:bg-blue-600"
    >
      <font-awesome-icon icon="fa-solid fa-angles-left" class="mr-1" />
      Буцах
    </button>

    <h1 class="mt-5 mb-3 text-center font-bold">
      {{ form.id ? "Уулзалтын өрөө засах" : "Уулзалтын өрөө нэмэх" }}
    </h1>

    <div class="flex items-center mb-3">
      <h4 class="w-[15rem]">
        Өрөөний нэр /дугаар/
        <span class="text-red-500">*</span>
      </h4>
      <input
        type="text"
        class="w-full border border-gray-300 rounded p-2"
        placeholder="Нэр"
        v-model="form.room_number"
      />
    </div>

    <div class="flex mb-3">
      <h4 class="w-[15rem]">
        Өрөөний зураг<span class="text-red-500">*</span>
      </h4>
      <div class="space-y-3 w-full">
        <div
          class="flex flex-col justify-center items-center"
          :class="mainImage ? 'w-3/4' : 'h-40 w-40'"
        >
          <img
            :src="imageSrc"
            alt="image"
            :class="!mainImage ? 'w-14 h-14' : ''"
          />
          <span v-if="!mainImage" class="text-xs text-gray-500"
            >Зураг байхгүй байна</span
          >
        </div>
        <input
          type="file"
          class="w-full border border-gray-300 rounded p-2"
          @change="onImageChange"
          accept="image/jpeg, image/png"
        />
        <span class="text-sky-500 text-xs">
          Зөвхөн jpg, jpeg, png өргөтгөлтэй зураг оруулна уу.
        </span>
      </div>
    </div>

    <div class="flex items-center mb-5">
      <h4 class="w-[15rem]">
        Өрөөний багтаамж
        <span class="text-red-500">*</span>
      </h4>
      <input
        type="text"
        class="w-full border border-gray-300 rounded p-2"
        placeholder="Багтаамж"
        v-model="form.capacity"
      />
    </div>

    <div class="flex items-center text-xs">
      <button
        @click="updateMeetingRoom()"
        class="bg-blue-500 p-2 rounded text-white mr-2 hover:scale-105"
      >
        <font-awesome-icon
          :icon="form.id ? 'fa-solid fa-pen' : 'fa-solid fa-add'"
          class="mr-1"
        />{{ !form.id ? "Нэмэх" : "Засах" }}
      </button>
      <button
        @click="resetForm()"
        class="bg-amber-500 p-2 rounded text-white hover:scale-105"
      >
        <font-awesome-icon icon="fa-solid fa-eraser" class="mr-1" />Арилгах
      </button>
    </div>
  </div>

  <SuccessModal v-if="success" :success="success" />
  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { onMounted, ref } from "vue";
import SuccessModal from "@/components/ui/SuccessModal.vue";
import ErrorModal from "@/components/ui/ErrorModal.vue";

export default {
  name: "YellowAddMeetingRoom",
  emits: ["closeMode"],
  props: {
    data: Object,
  },
  components: {
    SuccessModal,
    ErrorModal,
  },
  setup(props, { emit }) {
    const closeMode = () => {
      resetForm();
      emit("closeMode");
    };

    // Main image
    const defaultImage = require("@/assets/svg/image-not-found-icon.svg");
    const imageSrc = ref(defaultImage);
    const mainImage = ref("");

    const onImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageSrc.value = URL.createObjectURL(file);
        mainImage.value = file;
      } else {
        if (props.data.room_pic) {
          imageSrc.value = props.data.room_pic;
          mainImage.value = props.data.room_pic;
        } else {
          imageSrc.value = defaultImage;
          mainImage.value = null;
        }
      }
    };

    const success = ref(null);
    const error = ref(null);
    const form = ref({
      id: null,
      room_number: null,
      capacity: null,
    });

    onMounted(() => {
      if (props.data) {
        form.value.id = props.data.id;
        form.value.room_number = props.data.room_number;
        form.value.room_pic = props.data.room_pic;
        form.value.capacity = props.data.capacity;
        imageSrc.value = props.data.room_pic;
        mainImage.value = props.data.room_pic;
      }
    });

    const resetForm = () => {
      form.value = {
        id: null,
        room_number: null,
        capacity: null,
      };
      imageSrc.value = defaultImage;
      mainImage.value = null;
    };

    // VALIDATION
    const isValid = () => {
      if (!form.value.room_number) return alert("Өрөөний нэрийг оруулна уу");
      if (!form.value.capacity) return alert("Өрөөний багтаамжийг оруулна уу");
      return true;
    };

    // SUBMIT
    const updateMeetingRoom = async () => {
      if (!isValid()) return;

      const formData = new FormData();
      formData.append("image", mainImage.value);
      formData.append("room_number", form.value.room_number);
      formData.append("capacity", form.value.capacity);

      try {
        let res;

        if (!props.data) {
          res = await adminInstance.post(
            "/yellow-page/insert/meeting-room",
            formData
          );
        } else {
          formData.append("id", props.data.id);
          res = await adminInstance.post(
            "/yellow-page/update/meeting-room",
            formData
          );
        }

        if (res.status === 200) {
          success.value = "Амжилттай шинэчлэгдлээ.";
          resetForm();
          setTimeout(() => {
            success.value = false;
          }, 5000);
        }
      } catch (err) {
        error.value = "Алдаа гарлаа.";
        setTimeout(() => {
          error.value = false;
        }, 5000);
      }
    };

    return {
      closeMode,
      imageSrc,
      mainImage,
      form,
      resetForm,
      updateMeetingRoom,
      onImageChange,
      success,
      error,
    };
  },
};
</script>
